import { SxProps, Theme } from "@mui/material";
import { IHasLayout } from "../../Models/IHasLayout";
import { ComponentLayoutModel } from "./ComponentLayoutModel";

export default function getComponentLayout<T extends IHasLayout>(component: T): SxProps<Theme> | undefined {
  const componentLayout = component.Layout as ComponentLayoutModel;

  if (!componentLayout) {
    return undefined;
  }

  const componentLayoutSx = {
    height: componentLayout?.Height,
    width: componentLayout?.Width,

    flex: componentLayout?.Flex,
    flexGrow: componentLayout?.FlexGrow,
    flexShrink: componentLayout?.FlexShrink,

    alignItems: componentLayout?.AlignItems,
    alignContent: componentLayout?.AlignContent,
    justifyContent: componentLayout?.JustifyContent,

    margin: componentLayout?.Margin,
    marginTop: componentLayout?.MarginTop,
    marginBottom: componentLayout?.MarginBottom,
    marginLeft: componentLayout?.MarginLeft,
    marginRight: componentLayout?.MarginRight,

    padding: componentLayout?.Padding,
    paddingTop: componentLayout?.PaddingTop,
    paddingBottom: componentLayout?.PaddingBottom,
    paddingLeft: componentLayout?.PaddingLeft,
    paddingRight: componentLayout?.PaddingRight,
  };
  return componentLayoutSx;
}
